export default function formAPIreviewofsystem({
    rosname,
    DATE,
    date,
    doctorid,
    id,
    rosvalue,
    patientid,
    specialization,
    bookingid,
    doctorname,
    appointmentid,
    iscurrentvisit,
    updatedby,
    updateddate,
    updatedbyid,
    rostext

})
{
 
  return Object.freeze({
    rosname,
    DATE,
    date,
    doctorid,
    id,
    rosvalue,
    patientid,
    specialization,
    bookingid,
    doctorname,
    appointmentid,
    iscurrentvisit,
    updatedby,
    updateddate,
    updatedbyid,
    rostext
  });
}